<template>
   <div>
        <button
          type="button"
          class="btn wf-product-refinement-list-header-toggle collapsed text-transform-none font-weight-bold"
          data-toggle="collapse"
          :data-target="sectionId"
        >
          <div class="row">
          <div class="col-md-12">
            <h6 class="primary-heading font-weight-bold mb-2">
              {{ title }}
            </h6>
          </div>
          </div>
          <span
            class="
              plus-sm-icon
              png-icon
              png-icon-icons-glyph--red-minus-sm
              wf-product-refinement-list-header-toggle-inactive
            "
          />
          <span
            class="
              plus-sm-icon
              png-icon
              png-icon-icons-glyph--red-plus-sm
              wf-product-refinement-list-header-toggle-active
            "
          />
        </button>
      </div>
</template>

<script>
export default {
  props:['title', 'sectionId']
};
</script>
